// extracted by mini-css-extract-plugin
export default {"selectedPartnerBox":"l_yfxkt4Tjzk0cmEqGhx","listItem":"sIPGuO1iJKrwNvhSSQHS"};